import { AfterViewInit, ChangeDetectionStrategy, Component, OnInit, QueryList, ViewChildren, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { MatMenuPanel, MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { ActivatedRoute, Router } from '@angular/router';
import { UserManagerService } from '../../../../+shared/services/user-manager/user-manager.service';
import { AuthHeaderButtonsComponent } from '../../../../+shared/components/auth-header-buttons/auth-header-buttons.component';
import { MatMenuButtonComponent } from './mat-menu-button/mat-menu-button.component';

import { MatButton } from '@angular/material/button';
import { MatToolbar } from '@angular/material/toolbar';

export interface AdminLinkItem {
  name: string;
  links: AdminLink[];
}

export interface AdminLink {
  label: string;
  href?: string | null;
  routerLink: boolean;
}

@Component({
    selector: 'dish-admin-nav-bar',
    templateUrl: './admin-nav-bar.component.html',
    styleUrls: ['./admin-nav-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
    MatToolbar,
    MatButton,
    MatMenuButtonComponent,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    AuthHeaderButtonsComponent
]
})
export class AdminNavBarComponent implements AfterViewInit, OnInit {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private userManagerService = inject(UserManagerService);

  @ViewChildren(MatMenuTrigger) triggers: QueryList<MatMenuTrigger>;
  @ViewChildren('menu') panels: QueryList<MatMenuPanel>;
  menuClosedSubject$ = new Subject<string>();
  menuClosed$ = this.menuClosedSubject$.asObservable();

  userIsLoggedIn: boolean;
  currentUrl: string;

  menus: AdminLinkItem[] = [
    {
      name: 'Menus',
      links: [
        { label: 'Manage Menus', href: '/Admin/Templates', routerLink: false },
        {
          label: 'Manage Templates',
          href: '/Admin/Templates/Manage',
          routerLink: false,
        },
      ],
    },
    {
      name: 'Clients',
      links: [
        {
          label: 'Client Management',
          href: '/Admin/Clients',
          routerLink: false,
        },
        {
          label: 'Client Listing',
          href: '/Admin/Clients/Listing',
          routerLink: false,
        },
      ],
    },
    {
      name: 'Products',
      links: [
        {
          label: 'Corporate Products',
          href: '/Admin/CorporateProducts',
          routerLink: false,
        },
        {
          label: 'Client Products',
          href: '/Admin/ClientProducts',
          routerLink: false,
        },
        {
          label: 'Product Categories',
          href: '/Admin/ProductCategories',
          routerLink: false,
        },
      ],
    },
    {
      name: 'Filters',
      links: [
        {
          label: 'Allergens',
          href: '/Admin/Filters/Allergens',
          routerLink: false,
        },
        {
          label: 'Preferences',
          href: '/Admin/Filters/Preferences',
          routerLink: false,
        },
        {
          label: 'Filter Sets',
          href: '/Admin/Filters/Sets',
          routerLink: false,
        },
      ],
    },
  ];

  ngOnInit() {
    this.userIsLoggedIn = !this.userManagerService.loginRequired();
    this.currentUrl = this.router.url;
  }

  ngAfterViewInit() {
    this.triggers.forEach((trigger, i: number) => {
      trigger.menu = this.getMenu(i);
    });
  }

  menuClosed(menuName: string) {
    this.menuClosedSubject$.next(menuName);
  }

  openMenu(menuIndex: number) {
    this.triggers.toArray().forEach((trigger, i: number) => {
      if (i !== menuIndex && trigger.menuOpen) trigger.closeMenu();
      if (i === menuIndex) {
        trigger.openMenu();
      }
    });
  }

  getMenu(i: number) {
    return this.panels.toArray()[i];
  }

  navigateTo(href: string, isNg: boolean) {
    if (isNg) {
      this.router.navigateByUrl(href).then();
    } else {
      // TODO change this over to router.navigate once all of the admin pages are converted to Angular
      window.location.href = href;
    }
  }

  logout() {
    window.location.href = '/Account/Login';
  }
}
